// Application: Rede Mapper
import { cleanUndefined } from '@core/utils/clean-undefined';
import { Rede } from '@domain/rede/rede';
import { RedeDto } from '../dto/rede.dto';

export class RedeMapper {
  static toDomain(redeDto: Partial<RedeDto>): Partial<Rede> {
    return {
      id: redeDto.id,
      razaoSocial: redeDto.razaoSocial,
      nomeFantasia: redeDto.nomeFantasia,
      cnpj: redeDto.cnpj,
      uf: redeDto.uf
    };
  }

  static toDTO(rede: Partial<Rede>): Partial<RedeDto> {
    const DTO = {
      idRede: rede.id,
      razaoSocial: rede.razaoSocial,
      nomeFantasia: rede.nomeFantasia,
      cnpj: rede.cnpj,
      uf: rede.uf
    };
    return cleanUndefined(DTO);
  }
}
